import React from 'react'
import { MenuItem } from './MenuItem'
import { icons } from './platform'
import { useOnLogout } from './hooks'
import type { MenuListElement } from './menuList'

type Props = { username: string }

export const LoggedUserMenu = ({ username }: Props) => {
  const onLogout = useOnLogout()
  const menuElement: MenuListElement = {
    name: username,
    icon: icons.UserIcon,
    children: [
      {
        path: '/account/',
        name: 'Личный кабинет',
        icon: icons.Account
      },
      {
        name: 'Выйти',
        icon: icons.Exit,
        onClick: onLogout
      }
    ]
  }
  return <MenuItem key="1" right element={menuElement} level={1} />
}
